<template>
  <div class="brand-wrap">
    <MainHeader></MainHeader>
    <div class="main">
      <div class="list_card1" v-for="(item, index) in list" :key="index">
        <div style="margin-bottom: 20px;font-size: 16px;"><span style="font-size: 16px;margin-right: 3px;font-weight: bolder;">|</span>{{ item.name }}</div>
        <div class="item">
          <div class="list_card" v-for="(it, index) in item.arr" :key="index">
          <div class="info_wrap">
            <div class="title">
              <img class="coach_info_img1" :src="!it.isWant?it.src:it.repalacSrc">
            </div>
            <div class="des_wrap">
              <p class="name">{{ it.name }}</p>
              <p class="des">{{ it.des }}</p>
            </div>
          </div>
          <div class="card_bottom">
            <div class="coach_bottom_first">
              <!-- <span class="coach_span1">¥3500</span>
              <span class="coach_span2">起</span> -->
            </div>
            <div class="card_bottom_right">
              <span @click="wantClick(it)">报名咨询</span>
              <div class="box_item" style="transform: translate(-500px, -30px);"></div>
            </div>
          </div>
        </div>
        </div>
        
      </div>
    </div>
    <div class="footer" style="padding-top: 70px;padding-bottom: 10px;">
      <div style="max-width: 1206px;margin:0 auto;padding-bottom: 30px;">
        <img src="../assets/img/编组.png" alt="">
      </div>
      <div style="max-width: 1206px;margin: 0px auto;display: flex;justify-content: space-between;">
        <div style="width: 600px;height: 345px;padding-top: 15px;">
          <div style="line-height: 30px;font-size: 14px;font-weight: 400;color:#999">华警教育公司是一家由刘松、罗得水、栾翰林……等在公安联考、公务员考前培训行业从事10+年以上的一批资深老师共同成立的一家培训机构,专注于为全国警校生提供高质量联考培训服务的企业。针对公安联考考试设有独立的师资研究院,其中包括公安专业知识研究院、申论研究院、行测研究院、面试研究院.“四大研究院”共23名拥有一支10年以上行业经验的大咖,专注于研发最新的考试大纲和教授最新考试趋势内容,能够根据警校生的需求和特点，量身定制个性化的教学方案，科学的帮助学生提升在联考中拿到高分。</div>
          <div style="line-height: 30px;font-size: 14px;font-weight: 400;color:#999">华警教育秉承“忠党爱国、锐意进取”的教育理念,致力于为学员提供全方位的招警考试培训解决方案。</div>
          <div style="line-height: 30px;font-size: 14px;font-weight: 400;color:#999">为了保证教育培训服务的质量和效果，华警研究院采用了一系列先进的教学方法和教学技术。课程内容丰富多彩，涵盖了多个层次和难度，从基础系统到巩固提升、从巩固提升提升到强化刷题、从强化刷题到考前冲刺、让警校学子分阶段学习和吸收,在学习中感受到稳步提升。</div>
        </div>
        <div  style="display: flex;flex-direction: column;justify-content: space-between;">
          <div style="display: flex;">
            <img style="width: 26px;height: 26px;" src="../assets/img/编组14.png" alt="">
            <div style="margin-left: 10px;    padding-top: 5px;">
              <div style="color:#999">联系电话</div>
              <div style="color:#fff;margin-top: 10px;font-size: 14px;">18627592835</div>
            </div>
          </div>
          <div style="display: flex;">
            <img style="width: 26px;height: 26px;" src="../assets/img/编组15.png" alt="">
            <div style="margin-left: 10px;    padding-top: 5px;">
              <div style="color:#999">联系邮箱</div>
              <div style="color:#fff;margin-top: 10px;font-size: 14px;">327815144@qq.com</div>
            </div>
          </div>
          <div style="display: flex;">
            <img style="width: 26px;height: 26px;" src="../assets/img/编组16.png" alt="">
            <div style="width: 146px;margin-left: 10px;    padding-top: 5px;">
              <div style="color:#999">联系电话</div>
              <div style="color:#fff;margin-top: 10px;font-size: 14px;">中国（湖南）自由贸易试验区郴州片区郴州市白露塘镇林邑大道东侧郴州市战略性新兴产业园1.2栋701-C348室</div>
            </div>
          </div>
        </div>
        <div>
          <img style="" src="../assets/img/编组8.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
export default {
  components: {
    MainHeader
  },
  data() {
    return {
      list: [
        {
          name: '申论讲师', arr: [{ name: '刘松', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/1.jpg'), des: '《申论》讲师，超过15年申论教学经验相关工作经验，其中包括10年市委党校讲师、国考申论阅卷老师,对教学有一套严谨的教学方法和教学理念，累计培训学员超过20000+学员。' },
          { name: '范仓奇', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/2.jpg'), des: '《申论》讲师，11年授课经验。曾担任某大型公培机构师资研究院院长。担任讲师以来已累计培养了超过30万人。' },
          { name: '成全', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/3.jpg'), des: '《申论》讲师，长期奋战在课程研发、一线教学，教龄累积达20年，多次培训出高分状元，从事申论教学超过10年。善于引导性教学，激发学生自己思考的兴趣与能力。' },
          { name: '罗得水', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/4.jpg'), des: '《申论》讲师，教学以及研发经验13年。善于使用生活中的例子讲解抽象的概念，着重培养同学们开发项目的逻辑思维,授课市场达6万+课时。' },
          ]
        },
        {
          name: '行测讲师', arr: [{ name: '王晶晶', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/5.jpg'), des: '《行测》讲师，主攻言语理解、判断推理,13年一线教学经验，12年《行测》研发经验。具有丰富的项目开发及管理经验。授课总时长达7万+课时。' },
          { name: '李刚', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/6.jpg'), des: '《行测》讲师，7年教学经验，硕士研究生,《行测》科目考试大纲和考试的底层逻辑轻松拿捏。讲课经验丰富，通俗易懂，善用例子解释知识点。授课总时长达4万+课时。' },
          { name: '张鹏', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/7.jpg'), des: '《行测》讲师，7年体制内工作经验，7年教学经验，参与课程设计与研发等教学工作，对公安联考行测模考考试重难点分析十分到位，授课风格深入浅出，耐心亲和，严谨细腻，条理清晰，能很好的引导学生思考。' },
          { name: '李乐', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/8.jpg'), des: '《行测》讲师，7多年实战考试经验和授课经验，对《行测》有深刻的理解。曾工作认真负责，授课逻辑思维缜密，授课方式新颖独特，能够全程紧抓学员思路，受到学员的追捧。' },
          { name: '安健', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/9.jpg'), des: '《行测》讲师，10年教龄,主攻数量关系、资料分析。实践经验丰富，多次参加公务员招考,善于将理论与实际相结合，重点突出，引导学生深入思考。' },
          { name: '马兴', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/10.jpg'), des: '《行测》讲师，具有丰富的项目经验，曾参与了《行测的速度》、《数学关系高分技巧》等书籍的编著。注重让学生由浅入深接收知识,授课时长达3万+课时,深受学生喜欢。' },
          { name: '李国兵', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/11.jpg'), des: '《行测》讲师，13年研发及教学经验，接触公考以来,13年一直从事一线教学工作。有数、资的闪电侠之称.授课时长达4万+课时,深受学员追捧。' },
          { name: '张军', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/12.jpg'), des: '《行测》讲师,华警资深师资,拥有10年授课经验,主攻数量关系、资料分析、面试。授课时长达6万+课时。' },
          ]
        },
        {
          name: '公安专业课讲师', arr: [{ name: '肖佳伟', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/13.jpg'), des: '《公安基础知识》讲师,教学以及研发经验8年。善于使用生活中的例子讲解抽象的概念，着重培养同学们开发项目的逻辑思维,授课市场达6万+课时。' },
          { name: '栾翰林', isWant: false, repalacSrc: require('../assets/img/chat.png'), src: require('../assets/img/14.jpg'), des: '《公安基础知识》讲师, 教学以及研发经验13年。善于使用生活中的例子讲解抽象的法条，课堂氛围活跃、内容着重培养同学们开发项目的逻辑思维,授课市场达8万+课时。' },
          ]
        },
      ]
    }
  },
  methods: {
    wantClick(item) {
      this.$set(item, 'isWant', !item.isWant)
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-wrap {
  height: calc(100% - 37px);
  overflow: auto;

  .main {
    padding: 20px 40px;
    border-radius: 5px;
    background-color: #fff;
    max-width: 1200px;
    width: 100%;
    margin: 20px auto 20px;
    height: calc(100% - 110px);
    overflow-y: scroll;
    box-shadow: 0px 12px 20px 0px rgba(193, 193, 193, 0.7);
    
    .item{
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
    .list_card {
      width: 500px;
      // height: 217px;
      box-shadow: 2px 2px 11px 0px rgba(0, 78, 109, 0.1);
      background: #ffffff;
      border-radius: 20px;
      margin: 0 0px 20px 0;

      .info_wrap {
        display: flex;
        text-align: center;
        padding: 20px 30px;

        .title {
          width: 150px;

          img {
            width: 150px;
            max-width: -1px;
            border-radius: 3px;
          }
        }

        .des_wrap {
          width: 270px;
          text-align: left;
          margin-left: 20px;

          .name {
            font-size: 16px;
            font-weight: bold;
          }

          .des {
            margin-top: 10px;
            line-height: 25px;
          }
        }
      }

      .card_bottom {
        height: 76px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        background: #f9fcff;
        border-radius: 0px 0px 20px 20px;
        margin-top: 11px;

        .card_bottom_right {
          width: 200px;
          height: 40px;
          background: #e0f5ee;
          background-size: cover;
          text-align: center;
          line-height: 40px;
          font-size: 16px;
          color: #00c745;
          font-weight: 500;
          border-radius: 20px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          z-index: 2;

          // .box_item{
          //   transform: translate(-500px, -30px);
          //   width: 120px;
          //   height: 120px;
          //   background: radial-gradient(circle closest-side,#C3FF59,transparent);
          //   transition: all .2s;
          //   z-index: 1;
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          // }
        }

        .card_bottom_right:hover {
          background: #00c356;
          color: #fff;
        }
      }
    }

    .list_card:hover {
      background: linear-gradient(to bottom right, #efe4fd, #fff, #e6f1fe);
      box-shadow: 5px 5px 18px 0px rgba(0, 78, 109, 0.14);
      transform: translateY(-5px);
      transition: 0.3s;
    }
  }
  .footer{
    background-color: #323439;
    width: 100%;
  }
  
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    opacity: 0.5;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
  }
}
</style>